import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 pt-16 pb-8 px-4 sm:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <button
          data-testid="footer-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="block w-full text-left font-display font-black uppercase leading-none text-[16vw] lg:text-[10rem] text-outline-faint hover:text-outline-red transition-all duration-700 select-none"
        >
          Zo Pound
        </button>

        <div className="mt-10 grid sm:grid-cols-3 gap-8 font-mono text-xs uppercase tracking-widest text-gray-500">
          <div>
            <p className="text-gray-300 mb-3">The Show</p>
            <p className="normal-case tracking-normal text-gray-400 leading-relaxed">
              A Simplicity Films, LLC production. Written, produced and directed by Jean Luc.
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-gray-300 mb-1">Navigate</p>
            {["manifesto", "episodes", "music", "gallery", "founder", "contact"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-left hover:text-blood transition-colors"
              >
                {id}
              </button>
            ))}
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-gray-300 mb-1">Contact</p>
            <a data-testid="footer-email-link" href="mailto:simplicityfilmsllc@gmail.com" className="hover:text-blood transition-colors normal-case tracking-normal">
              simplicityfilmsllc@gmail.com
            </a>
            <Link data-testid="footer-admin-link" to="/admin" className="hover:text-blood transition-colors">
              Admin Portal
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-gray-600">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Simplicity Films, LLC</span>
          <span className="flex items-center gap-2">
            <span className="w-4 h-2.5 flex flex-col overflow-hidden">
              <span className="flex-1 bg-royal" />
              <span className="flex-1 bg-blood" />
            </span>
            Haiti · Miami · Respect
          </span>
        </div>
      </div>
    </footer>
  );
}
